// extracted by css-extract-rspack-plugin
export default {"wrapper":"MenuSearch_wrapper__+sZyF","closeIconButton":"MenuSearch_closeIconButton__ucsmS"};